// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../fragments/money.fragment.generated';
export const KlarnaFinanceOptionsFragmentDoc = gql`
    fragment klarnaFinanceOptions on KlarnaFinanceOption {
  __typename
  perMonth {
    ...money
  }
}
    ${MoneyFragmentDoc}`;